export default "__VITE_ASSET__b1e24180__"